// polyfills, include if needed
//import "@babel/polyfill";
//import 'es6-promise/auto'
//import 'regenerator-runtime/runtime'
//import 'core-js'

import isTouchDevice from 'is-touch-device'
import staticVars from './static-vars/static-vars'


if (isTouchDevice() ) {
  document.body.classList.add('touch')
} else {
  document.body.classList.add('not-touch')
}

import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css' // optional for styling

const tooltips = [...document.querySelectorAll('.tooltip')]
for (let tooltip of tooltips) {
  tippy(tooltip, {
    content: tooltip.dataset.tooltipText,
  })

}


// css for webpack
import '../../scss/style.scss'

import initMenuMobile from './Menu/MenuMobile'
import initMenuDesktop from './Menu/Menu'

initMenuMobile()
initMenuDesktop()

import AnchorLink from './AnchorLink/AnchorLink'
let links = [].slice.call(document.querySelectorAll('a'), 0)

links = links.filter(item => item.href.indexOf('/#') > -1)
for (let link of links) {
  new AnchorLink(link)
}



import ToggleElement from './utils/ToggleElement.js'
const ToggleTriggers = [].slice.call(document.querySelectorAll('.toggle-trigger'), 0)
for (let trigger of ToggleTriggers) {
  new ToggleElement(trigger)
}

import {HeaderScroll} from './HeaderScroll/HeaderScroll'
HeaderScroll()

import {CardsFlip} from './CardsFlip/CardsFlip'
CardsFlip()

const langChooser = document.querySelector('.lang-chooser')
if (langChooser) {
  langChooser.addEventListener('change', evt => {
    window.location.href = `${evt.target.value}`
  })
}


if ('loading' in HTMLImageElement.prototype) {

  const images = document.querySelectorAll('img[loading="lazy"]')
  for (let img of images) {
    if (img.dataset.src) {
      img.src = img.dataset.src
    }

    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset
    }

    if (img.dataset.sizes) {
      img.sizes = img.dataset.sizes
    }
  }
} else {

  document.body.classList.add('loading-not-supported')
  // Dynamically import the LazySizes library
  const script = document.createElement('script')
  script.src = staticVars.templateUrl + '/assets/js/lazysizes.min.js'
  document.body.appendChild(script)
}

import TwoColumns from './TwoColumns/TwoColumns'
const twoColumnsModule = [...document.querySelectorAll('.m-two_columns')]
for (let module of twoColumnsModule) {
  const TwoColumnsLayout = new TwoColumns(module)
  TwoColumnsLayout.init()
  TwoColumnsLayout.update()
}


/*import {Breadcrumb} from './Breadcrumb/Breadcrumb';
Breadcrumb()*/
